// postMessage protocol v1 between @xceed/checkout (parent) and this page.
// Spec: B2C-1852. Constants are intentionally duplicated in the checkout repo
// (no shared package); the `v` field guards against drift.
//
// The iframe never initiates: the parent sends `hello` (retrying until it
// gets `ready`, since the iframe may not be listening yet), and the iframe
// only ever replies to the origin captured from that handshake.

export const PROTOCOL_VERSION = 1

export const MSG = {
  HELLO: 'xceed-captcha:hello',
  READY: 'xceed-captcha:ready',
  REQUEST_TOKEN: 'xceed-captcha:request-token',
  TOKEN: 'xceed-captcha:token',
  ERROR: 'xceed-captcha:error',
} as const

export type ErrorReason =
  | 'turnstile-error'
  | 'expired'
  | 'timeout'
  | 'config-error'

export interface HelloMessage {
  type: typeof MSG.HELLO
  v: number
}

export interface ReadyMessage {
  type: typeof MSG.READY
  v: number
}

export interface RequestTokenMessage {
  type: typeof MSG.REQUEST_TOKEN
  v: number
  requestId: string
  action: string
}

export interface TokenMessage {
  type: typeof MSG.TOKEN
  v: number
  requestId: string
  token: string
}

export interface ErrorMessage {
  type: typeof MSG.ERROR
  v: number
  requestId: string
  reason: ErrorReason
}

export type OutboundMessage = ReadyMessage | TokenMessage | ErrorMessage
